export const snakeCaseFromCamelCase = (str) => {
    if (!str) {
        return str
    }
    return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
}
